import { render, staticRenderFns } from "./SidebarLayers.vue?vue&type=template&id=7fa539e8"
import script from "./SidebarLayers.vue?vue&type=script&lang=ts"
export * from "./SidebarLayers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports